var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRingL(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 1206.92,
    height: 1666.84,
    viewBox: "0 0 1206.92 1666.84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 9",
    opacity: 0.23,
    d: "M603.462 0.779297C769.791 0.779479 920.443 93.8867 1029.54 244.56C1138.64 395.232 1206.14 603.422 1206.14 833.418C1206.14 1063.41 1138.64 1271.6 1029.54 1422.28C920.443 1572.95 769.791 1666.06 603.462 1666.06C437.133 1666.06 286.48 1572.95 177.381 1422.28C68.2822 1271.6 0.779321 1063.41 0.779297 833.418C0.779297 603.422 68.2822 395.232 177.381 244.56C286.48 93.8865 437.133 0.779297 603.462 0.779297Z",
    stroke: "url(#paint0_linear_0_35)",
    strokeWidth: 1.55794
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_35",
    x1: 603.461,
    y1: 0,
    x2: 603.461,
    y2: 1666.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    style: {
      stopColor: "#D9D9D9",
      stopColor: "color(display-p3 0.8510 0.8510 0.8510)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingL);
export default __webpack_public_path__ + "static/media/ring-l.3da3a6d8756a53b58e5c945e7db66b72.svg";
export { ForwardRef as ReactComponent };